/**
 * HomeFAQ — Su'aalaha Inta Badan La Isweydiiyo (FAQ Section)
 *
 * Accordion-ka su'aalaha iyo jawaabaha
 * FAQ data-giisa wuxuu ku jiraa: data/faqData.js
 *
 * Waxaad ka bedeli kartaa:
 *  - Su'aalaha iyo jawaabaha (data/faqData.js)
 *  - Badge text-ka "SU'AALAHA" (line 23)
 *  - Heading-ka (line 28)
 *  - Subtitle-ka (line 31)
 */
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "../../components/ui/accordion";

/* ── Data — su'aalaha iyo jawaabaha ── */
import { faqs } from "./data/faqData";

export default function HomeFAQ() {
  return (
    <section className="py-24 sm:py-32 border-t border-border section-muted">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">

        {/* ── Heading ── */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          <span className="inline-block rounded-full px-4 py-1.5 text-xs font-semibold text-accent border border-accent/20 bg-accent/5 mb-4">
            SU'AALAHA
          </span>
          <h2
            className="font-heading font-bold text-navy"
            style={{ fontSize: "clamp(1.75rem, 4vw, 2.75rem)", letterSpacing: "-0.03em" }}
          >
            Su'aalaha Inta Badan La Isweydiiyo
          </h2>
          <p className="mt-4 text-muted">
            Wax kasta oo aad u baahan tahay inaad ka ogaato GanacsiHub.
          </p>
        </motion.div>

        {/* ── Accordion ── */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
        >
          <Accordion type="single" collapsible className="space-y-0">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border-b border-border"
              >
                <AccordionTrigger className="py-5 text-left">
                  <span className="text-base font-semibold text-navy">{faq.q}</span>
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm text-muted leading-relaxed">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
